app.controller('sendFormController', [
    '$scope',
    '$mdDialog',
    'templates',
    'patientId',
    'patientName',
    'patientEmail',
    'Session',
    'PatientFormsAPI',
    '$modal',
    '$timeout',
    '$window',
    '$q',
    'CUSTOM_FORM_COMPONENT_TYPES',
    function ($scope, $mdDialog, templates, patientId, patientName, patientEmail, Session, PatientFormsAPI, $modal, $timeout, $window, $q, CUSTOM_FORM_COMPONENT_TYPES) {
        // The API rejects anything larger; caught here so the patient-facing template
        // is never saved with an image that silently failed to upload.
        const MAX_IMAGE_BYTES = 20 * 1024 * 1024;

        /* Array.isArray, not `|| []`: the list endpoint returns a bare array, but a 204
           or an error body would give an object, and rebuildGroups' forEach would throw
           during construction - which takes the whole dialog down rather than showing
           an empty rail. */
        $scope.templates = Array.isArray(templates) ? templates : [];
        function templateIdOf(template) {
            if (!template) return null;
            return template.id || template.patient_custom_form_template_id || null;
        }

        function templateTitleOf(template) {
            if (!template) return 'Untitled template';
            return template.name || template.form_title || 'Untitled template';
        }

        $scope.selectedTemplate = $scope.templates.length ? templateIdOf($scope.templates[0]) : null;
        $scope.patientId = patientId;
        $scope.recipientEmail = patientEmail || '';
        $scope.patientName = patientName || '';
        $scope.patientInitials = ($scope.patientName || '')
            .split(/\s+/)
            .filter(function (part) { return !!part; })
            .slice(0, 2)
            .map(function (part) { return part.charAt(0).toUpperCase(); })
            .join('') || '?';
        $scope.PatientFormsAPI = PatientFormsAPI;
        $scope.answersView = {
            loading: false,
            error: '',
            items: [],
        };
        $scope.previewSendState = {
            success: '',
            error: '',
        };
        $scope.previewBlocks = [];
        const EMPTY_LIST = [];
        const conditionalSourceCache = {};
        const conditionalOptionsCache = {};

        function clearConditionalCaches() {
            Object.keys(conditionalSourceCache).forEach(function (key) {
                delete conditionalSourceCache[key];
            });
            Object.keys(conditionalOptionsCache).forEach(function (key) {
                delete conditionalOptionsCache[key];
            });
        }

        /* Options are edited a row at a time, so a question carries {uid, text} objects
           rather than one comma-separated string. Everything downstream wants the plain
           text of the filled-in rows, in order, which is what this returns. */
        function getOptionTexts(question) {
            return getUsableOptions(question)
                .filter(function (option) { return !isImageOption(option); })
                .map(function (option) { return String(option.text).trim(); });
        }

        /* The single answer to "which option rows are real", in order. Everything that
           derives an option's component id from its position - the payload, the
           conditional pickers, the image uploads - goes through here, so they cannot
           disagree about which rows counted. A text row counts once it has text; an
           image row counts once it has an image. */
        function getUsableOptions(question) {
            if (!question || !Array.isArray(question.options)) return [];
            return question.options.filter(function (option) {
                if (!option) return false;
                if (isImageOption(option)) return optionHasImage(option);
                return !!String(option.text || '').trim();
            });
        }

        function getQuestionOptionsSignature(question) {
            if (!question) return '';
            if (question.responseType === 'yesNo') return 'yesNo';
            if ($scope.isTextChoiceType(question.responseType)) {
                return JSON.stringify(getOptionTexts(question)) + (question.allowOther ? '|other' : '');
            }
            if ($scope.isImageQuestionType(question.responseType)) {
                return JSON.stringify(getUsableOptions(question).map(function (option) {
                    return String(option.altText || '').trim() + '|' + (option.file ? option.file.name : 'stored');
                }));
            }
            return '';
        }

        function getQuestionSignature(question) {
            if (!question) return '';
            return [
                question.kind || '',
                question.label || '',
                question.responseType || '',
                getQuestionOptionsSignature(question),
            ].join('::');
        }

        function getSourceQuestionsSignature(questions, questionIndex) {
            return questions
                .slice(0, questionIndex)
                .map(function (question, index) {
                    return index + ':' + getQuestionSignature(question);
                })
                .join('||');
        }
        $scope.drawer = {
            activeRoot: 'create',
            templateAction: 'preview',
        };
        $scope.groups = [];

        function rebuildGroups() {
            const groups = [
                // {
                //     id: 'create',
                //     title: 'Create New Template',
                //     isCreate: true,
                //     collapsed: false,
                //     items: [
                //         {
                //             key: 'create',
                //             label: 'Create New Template',
                //             icon: 'fa-plus',
                //             action: 'create',
                //         },
                //     ],
                // },
            ];

            ($scope.templates || []).forEach(function (template) {
                const templateId = templateIdOf(template);
                groups.push({
                    id: templateId,
                    title: templateTitleOf(template),
                    isTemplate: true,
                    template: template,
                    collapsed: $scope.drawer.activeRoot !== templateId,
                    items: [
                        // { key: 'edit', label: 'Edit', icon: 'fa-edit', action: 'edit' },
                        { key: 'preview', label: 'Preview and Send', icon: 'fa-eye', action: 'preview' },
                        { key: 'answers', label: 'Check Answers', icon: 'fa-list', action: 'answers' },
                        // { key: 'delete', label: 'Delete', icon: 'fa-trash', action: 'delete' },
                    ],
                });
            });

            $scope.groups = groups;
        }

        /* Keyed by option component_id throughout, the same value the patient's answer
           carries as answer_id. Matching options by their text worked only for text
           options and broke the moment two options read alike; images have no text to
           match on at all. There is no separate image bucket - an image question is a
           single-select like any other. */
        function resetPreviewState() {
            $scope.previewState = {
                text: {},
                single: {},
                multi: {},
            };
        }

        resetPreviewState();

        /* ng-repeat tracks builder questions by uid rather than $index. Reordering or
           removing a question used to shuffle answers through reused DOM nodes, which
           left Material's floating labels stuck over the wrong field. */
        let questionUidSeq = 0;
        let optionUidSeq = 0;

        function nextQuestionUid() {
            questionUidSeq += 1;
            return 'q-' + questionUidSeq;
        }

        /* An option row is either text or an image; the API models both as components
           inside question_options and tells them apart by alt_text. `file` holds the
           browser File until the template has been saved and the option has a real
           component id to PUT the bytes against; `previewSrc` is what the builder
           draws, either a local data URL or an object URL fetched back from S3. */
        function defaultOption(text) {
            optionUidSeq += 1;
            return {
                uid: 'o-' + optionUidSeq,
                text: text || '',
                isImage: false,
                altText: '',
                file: null,
                previewSrc: '',
                hasStoredImage: false,
            };
        }

        function defaultImageOptionRow(altText) {
            const option = defaultOption('');
            option.isImage = true;
            option.altText = altText || '';
            return option;
        }

        function isImageOption(option) {
            return !!(option && option.isImage);
        }

        /* "Other" is a real option on the wire - a text option like any other, so it has
           a component_id the patient's answer_id can point at. What makes it special is
           only that picking it also submits an answer_string on the same question. The
           label is fixed so it can be recognised again when the template is reloaded;
           there is nowhere in the schema to record "this one is the other option". */
        const OTHER_OPTION_TEXT = 'Other';

        function isOtherOptionText(text) {
            return String(text || '').trim().toLowerCase() === OTHER_OPTION_TEXT.toLowerCase();
        }

        function questionAllowsOther(question) {
            return !!(question && question.allowOther && $scope.isTextChoiceType(question.responseType));
        }

        function optionHasImage(option) {
            return !!(option && option.isImage && (option.file || option.hasStoredImage || option.previewSrc));
        }

        function defaultVisibility() {
            return {
                enabled: false,
                sourceQuestionIndex: null,
                lastSourceQuestionIndex: null,
                operator: 'EQUALS',
                selectedOptionId: null,
                selectedOptionIds: [],
                value: '',
            };
        }

        /* builder.questions holds every component on the form, not just questions; `kind`
           says which. Ids are still derived from position across the whole list, so a
           header or image takes a componentId like any question does. */
        function defaultQuestion() {
            return {
                uid: nextQuestionUid(),
                kind: 'question',
                label: '',
                responseType: 'freeText',
                required: false,
                allowOther: false,
                options: [],
                visibility: defaultVisibility(),
            };
        }

        function defaultHeader(headerText) {
            return {
                uid: nextQuestionUid(),
                kind: 'header',
                headerText: headerText || '',
                visibility: defaultVisibility(),
            };
        }

        /* Shaped like an image option row (file, previewSrc, storedImage, storedComponentId)
           so the same preview loading and upload code serves both. */
        function defaultImage(altText) {
            return {
                uid: nextQuestionUid(),
                kind: 'image',
                altText: altText || '',
                file: null,
                previewSrc: '',
                storedImage: null,
                hasStoredImage: false,
                visibility: defaultVisibility(),
            };
        }

        const COMPONENT_FACTORIES = {
            question: defaultQuestion,
            header: function () { return defaultHeader(); },
            image: function () { return defaultImage(); },
        };

        $scope.componentTypes = CUSTOM_FORM_COMPONENT_TYPES.filter(function (type) {
            return !!COMPONENT_FACTORIES[type.kind];
        });

        function isQuestionItem(item) {
            return !!item && (item.kind || 'question') === 'question';
        }

        function buildOptionComponentId(questionIndex, optionIndex) {
            return (questionIndex + 1) * 1000 + optionIndex + 1;
        }

        function normalizeOptionText(text) {
            return String(text || '').trim().toLowerCase();
        }

        function getQuestionOptionItems(question, questionIndex) {
            if (!question) return [];

            if (question.responseType === 'yesNo') {
                return [
                    { id: buildOptionComponentId(questionIndex, 0), text: 'Yes' },
                    { id: buildOptionComponentId(questionIndex, 1), text: 'No' },
                ];
            }

            if (
                question.responseType === 'singleChoice'
                || question.responseType === 'multipleChoice'
                || question.responseType === 'imageChoice'
            ) {
                const rows = getUsableOptions(question).slice();
                if (questionAllowsOther(question)) {
                    rows.push({ text: OTHER_OPTION_TEXT, isImage: false });
                }

                return rows.map(function (option, optionIndex) {
                    return {
                        id: buildOptionComponentId(questionIndex, optionIndex),
                        text: isImageOption(option)
                            ? (String(option.altText || '').trim() || 'Image ' + (optionIndex + 1))
                            : String(option.text || '').trim(),
                    };
                });
            }

            return [];
        }

        function getEnforcedVisibilityOperatorBySourceQuestion(sourceQuestion) {
            return sourceQuestion && sourceQuestion.responseType === 'freeText'
                ? 'IS_ANSWERED'
                : 'EQUALS';
        }

        function getSourceQuestionFromVisibility(question) {
            const sourceIndex = getVisibilitySourceIndex(question);
            if (sourceIndex === null) {
                return null;
            }

            return ($scope.builder && Array.isArray($scope.builder.questions))
                ? $scope.builder.questions[sourceIndex]
                : null;
        }

        function enforceConditionalOperator(question) {
            if (!question || !question.visibility) return;

            const sourceQuestion = getSourceQuestionFromVisibility(question);
            const operator = getEnforcedVisibilityOperatorBySourceQuestion(sourceQuestion);
            question.visibility.operator = operator;

            if (operator === 'IS_ANSWERED') {
                question.visibility.selectedOptionId = null;
                question.visibility.selectedOptionIds = [];
                question.visibility.value = '';
            }
        }

        function normalizeValue(value) {
            return String(value || '').trim().toLowerCase();
        }

        function normalizeId(value) {
            if (value === null || value === undefined) return '';
            return String(value).trim();
        }

        function getConditionOptionIds(condition) {
            if (!condition) return [];

            const optionIds = condition.optionIds !== undefined ? condition.optionIds : condition.option_ids;

            if (Array.isArray(optionIds)) {
                return optionIds;
            }

            if (typeof optionIds === 'number') {
                return [optionIds];
            }

            if (typeof optionIds === 'string') {
                const text = optionIds.trim();
                if (!text) return [];

                if (text.indexOf(',') > -1) {
                    return text.split(',').map(function (part) { return part.trim(); }).filter(function (part) { return !!part; });
                }

                return [text];
            }

            return [];
        }

        function idsMatch(left, right) {
            const leftText = normalizeId(left);
            const rightText = normalizeId(right);

            if (leftText === rightText) {
                return true;
            }

            const leftNumber = Number(leftText);
            const rightNumber = Number(rightText);
            if (!Number.isNaN(leftNumber) && !Number.isNaN(rightNumber)) {
                return leftNumber === rightNumber;
            }

            return false;
        }

        function getVisibilitySourceIndex(question) {
            if (!question || !question.visibility) return null;
            const raw = question.visibility.sourceQuestionIndex;
            // Number(null) is 0, which would quietly pick the first item - now possibly a header.
            if (raw === null || raw === undefined || raw === '') return null;
            const sourceIndex = Number(raw);
            if (!Number.isInteger(sourceIndex) || sourceIndex < 0) {
                return null;
            }
            return sourceIndex;
        }

        function getPreviewBlockKey(block, blockIndex) {
            const id = wireComponentId(block);
            if (id !== undefined && id !== null) {
                return String(id);
            }
            return 'idx-' + blockIndex;
        }

        /* Preview renders both shapes - a saved template straight off the wire, and the
           builder's own questions before they are saved - so it reuses the same
           resolver the edit path does. */
        function getPreviewResponseType(block) {
            if (!block) return 'freeText';
            return resolveResponseType(block);
        }

        function resetBuilder(mode) {
            clearConditionalCaches();
            $scope.builder = {
                mode: mode || 'create',
                editTemplateId: null,
                name: '',
                questions: [defaultQuestion()],
                error: '',
            };
        }

        resetBuilder('create');

        function getSelectedTemplateObj() {
            return $scope.templates.find(function (template) {
                return templateIdOf(template) === $scope.selectedTemplate;
            });
        }

        $scope.getTemplateTitle = function (template) {
            return templateTitleOf(template);
        };

        $scope.getSelectedTemplateObj = getSelectedTemplateObj;

        /* The pane is an ng-switch rather than a row of sibling ng-ifs so exactly one
           section is ever mounted - two of them briefly overlapping was what made the
           right-hand side jump while switching between templates. The default branch
           also gives the pane something to show if the selected template disappears
           from under it, rather than going blank. */
        $scope.currentPane = function () {
            if ($scope.drawer.activeRoot === 'create' || $scope.drawer.templateAction === 'edit') {
                return 'builder';
            }
            if (!getSelectedTemplateObj()) {
                return 'empty';
            }
            if ($scope.drawer.templateAction === 'preview') {
                return 'preview';
            }
            if ($scope.drawer.templateAction === 'answers') {
                return 'answers';
            }
            return 'empty';
        };

        function refreshPreviewComponents() {
            const selected = getSelectedTemplateObj();
            $scope.previewBlocks = selected && $scope.getPreviewComponents
                ? $scope.getPreviewComponents(selected)
                : [];
        }

        $scope.selectCreateMenu = function () {
            $scope.drawer.activeRoot = 'create';
            $scope.drawer.templateAction = 'create';
            resetBuilder('create');
            rebuildGroups();
        };

        $scope.toggleGroup = function (group) {
            if (!group) return;
            if (group.isCreate) {
                $scope.selectCreateMenu();
                return;
            }
            if (!group.isTemplate || !group.template) return;

            if (group.collapsed) {
                const templateId = templateIdOf(group.template);
                $scope.selectedTemplate = templateId;
                $scope.drawer.activeRoot = templateId;
                if ($scope.drawer.templateAction === 'create') {
                    $scope.drawer.templateAction = 'preview';
                }
                if ($scope.drawer.templateAction === 'preview') {
                    resetPreviewState();
                    refreshPreviewComponents();
                }
                rebuildGroups();
                return;
            }

            $scope.drawer.activeRoot = null;
            rebuildGroups();
        };

        $scope.selectGroupItem = function (item, group) {
            if (!item || !group) return;

            if (group.isCreate || item.action === 'create') {
                $scope.selectCreateMenu();
                return;
            }

            if (group.template) {
                const templateId = templateIdOf(group.template);
                $scope.selectedTemplate = templateId;
                $scope.drawer.activeRoot = templateId;
            }

            if (item.action === 'delete') {
                $scope.deleteSelectedTemplate();
                return;
            }

            $scope.setTemplateAction(item.action);
            rebuildGroups();
        };

        $scope.isGroupItemActive = function (item, group) {
            if (!item || !group) return false;
            if (group.isCreate && item.action === 'create') {
                return $scope.drawer.activeRoot === 'create';
            }
            if (!group.template) return false;
            return $scope.drawer.activeRoot === templateIdOf(group.template)
                && $scope.drawer.templateAction === item.action;
        };

        /* Wire helpers. A saved component only ever comes back snake_case, but the
           same code renders builder-shaped questions in preview, so both spellings
           are read here rather than at twenty call sites. */
        function wireOptions(component) {
            if (!component) return [];
            const options = component.questionOptions || component.question_options;
            return Array.isArray(options) ? options : [];
        }

        function wireOptionText(option) {
            if (!option) return '';
            const text = option.textContent !== undefined ? option.textContent : option.text_content;
            return text ? String(text) : '';
        }

        function wireOptionAltText(option) {
            if (!option) return '';
            const alt = option.altText !== undefined ? option.altText : option.alt_text;
            return alt ? String(alt) : '';
        }

        function wireOptionIsImage(option) {
            return !!wireOptionAltText(option) && !wireOptionText(option);
        }

        function wireComponentId(component) {
            if (!component) return null;
            return component.componentId !== undefined ? component.componentId : component.component_id;
        }

        function wireQuestionText(component) {
            if (!component) return '';
            const text = component.questionText !== undefined ? component.questionText : component.question_text;
            return text ? String(text) : '';
        }

        function wireDisplayStyle(component) {
            if (!component) return '';
            return component.displayStyle || component.display_style || '';
        }

        function wireAllowMultiple(component) {
            if (!component) return false;
            return !!(component.allowMultipleSelections || component.allow_multiple_selections);
        }

        function wireVisibilityConditions(component) {
            if (!component) return [];
            const conditions = component.visibilityConditions || component.visibility_conditions;
            return Array.isArray(conditions) ? conditions : [];
        }

        function wireConditionSourceId(condition) {
            if (!condition) return null;
            return condition.sourceComponentId !== undefined
                ? condition.sourceComponentId
                : condition.source_component_id;
        }

        function wireHeaderText(component) {
            if (!component) return '';
            const text = component.headerText !== undefined ? component.headerText : component.header_text;
            return text ? String(text) : '';
        }

        /* Same rule the API's type deduction uses: a header is recognised by its header
           fields, a top-level image by alt text or stored image with nothing of a question. */
        function wireIsHeader(component) {
            if (!component) return false;
            return !!wireHeaderText(component)
                || component.headerSize !== undefined
                || component.header_size !== undefined;
        }

        function wireIsImage(component) {
            if (!component || wireQuestionText(component) || wireOptions(component).length) return false;
            return !!(wireOptionAltText(component) || component.image);
        }

        /* Type is derived from the wire shape alone. Nothing carries a responseType
           back from the server - it is not in the schema - so a saved question has to
           be recognised from its options: all images means an image question, a Yes/No
           text pair means yesNo, CHECKBOX means multi, any options means single, none
           means free text. */
        function resolveResponseType(question) {
            if (question.responseType) {
                return question.responseType;
            }

            const options = wireOptions(question);

            if (options.length > 0 && options.every(wireOptionIsImage)) {
                return 'imageChoice';
            }

            if (wireDisplayStyle(question) === 'CHECKBOX' || wireAllowMultiple(question)) {
                return 'multipleChoice';
            }

            if (options.length === 2) {
                const values = options.map(function (option) {
                    return wireOptionText(option).trim().toLowerCase();
                });
                if (values[0] === 'yes' && values[1] === 'no') {
                    return 'yesNo';
                }
            }

            if (options.length > 0) {
                return 'singleChoice';
            }

            return 'freeText';
        }

        function normalizeQuestion(templateQuestion) {
            const source = templateQuestion || {};
            const responseType = resolveResponseType(source);
            let options = [];
            let detectedAllowOther = false;

            if (Array.isArray(source.options)) {
                // Already builder-shaped (an unsaved question passed back through).
                options = source.options.map(function (option) {
                    return typeof option === 'object' && option !== null
                        ? option
                        : defaultOption(option);
                });
            } else {
                const wireRows = wireOptions(source).slice();

                // A trailing text option reading "Other" was written by the toggle below,
                // so it comes back off the list and turns the toggle on rather than
                // showing up as an editable row the user could rename or reorder.
                if (
                    $scope.isTextChoiceType(responseType)
                    && wireRows.length > 1
                    && isOtherOptionText(wireOptionText(wireRows[wireRows.length - 1]))
                ) {
                    wireRows.pop();
                    detectedAllowOther = true;
                }

                options = wireRows.map(function (option) {
                    if (wireOptionIsImage(option)) {
                        const row = defaultImageOptionRow(wireOptionAltText(option));
                        row.storedComponentId = wireComponentId(option);
                        /* The image metadata has to survive the round trip. On update the
                           server replaces the component list wholesale and then deletes any
                           S3 object the new list no longer references, so dropping this
                           field does not merely lose the link - it deletes the image. */
                        row.storedImage = option.image || null;
                        row.hasStoredImage = !!row.storedImage;
                        return row;
                    }
                    return defaultOption(wireOptionText(option));
                });
            }

            return {
                uid: nextQuestionUid(),
                kind: 'question',
                componentId: wireComponentId(source),
                label: source.label || wireQuestionText(source),
                responseType: responseType,
                required: !!source.required,
                allowOther: source.allowOther !== undefined ? !!source.allowOther : detectedAllowOther,
                options: options,
                visibility: defaultVisibility(),
            };
        }

        function normalizeComponent(templateComponent) {
            const source = templateComponent || {};

            if (source.kind === 'header' || wireIsHeader(source)) {
                const header = defaultHeader(wireHeaderText(source));
                header.componentId = wireComponentId(source);
                return header;
            }

            if (source.kind === 'image' || wireIsImage(source)) {
                const image = defaultImage(wireOptionAltText(source));
                image.componentId = wireComponentId(source);
                image.storedComponentId = wireComponentId(source);
                // Must be sent back on update, or the server deletes the stored file.
                image.storedImage = source.storedImage || source.image || null;
                image.hasStoredImage = !!image.storedImage;
                return image;
            }

            return normalizeQuestion(source);
        }

        function loadQuestionsFromTemplate(template) {
            let sourceQuestions = [];
            if (Array.isArray(template.questions) && template.questions.length > 0) {
                sourceQuestions = template.questions;
            } else if (Array.isArray(template.components) && template.components.length > 0) {
                sourceQuestions = template.components
                    .slice()
                    .sort(function (a, b) {
                        const aIndex = typeof a.orderIndex === 'number' ? a.orderIndex : 0;
                        const bIndex = typeof b.orderIndex === 'number' ? b.orderIndex : 0;
                        return aIndex - bIndex;
                    })
                    .filter(function (component) {
                    return component && (
                        wireQuestionText(component) || component.responseType || wireOptions(component).length
                        || wireIsHeader(component) || wireIsImage(component)
                    );
                });
            }

            if (sourceQuestions.length === 0) {
                return [defaultQuestion()];
            }

            const normalizedQuestions = sourceQuestions.map(normalizeComponent);
            const componentIndexById = {};

            sourceQuestions.forEach(function (question, index) {
                const id = wireComponentId(question);
                if (id !== undefined && id !== null) {
                    componentIndexById[id] = index;
                }
            });

            normalizedQuestions.forEach(function (builderQuestion, questionIndex) {
                const sourceQuestion = sourceQuestions[questionIndex];
                if (!sourceQuestion || wireVisibilityConditions(sourceQuestion).length === 0) {
                    return;
                }

                const condition = wireVisibilityConditions(sourceQuestion)[0];
                const conditionSourceId = wireConditionSourceId(condition);
                if (conditionSourceId === undefined || conditionSourceId === null) {
                    return;
                }

                const sourceIndex = componentIndexById[conditionSourceId];
                if (sourceIndex === undefined || sourceIndex === null || sourceIndex >= questionIndex) {
                    return;
                }
                // Only a question has an answer to show something on.
                if (!isQuestionItem(normalizedQuestions[sourceIndex])) {
                    return;
                }

                builderQuestion.visibility.enabled = true;
                builderQuestion.visibility.sourceQuestionIndex = sourceIndex;
                builderQuestion.visibility.lastSourceQuestionIndex = sourceIndex;
                builderQuestion.visibility.operator = getEnforcedVisibilityOperatorBySourceQuestion(normalizedQuestions[sourceIndex]);

                const sourceQuestionComponent = sourceQuestions[sourceIndex] || {};
                const sourceOptionItems = getQuestionOptionItems(normalizedQuestions[sourceIndex], sourceIndex);

                const conditionOptionIds = getConditionOptionIds(condition);
                if (conditionOptionIds.length > 0) {
                    let resolvedSelectedOptionId = null;

                    // Prefer id/order based mapping from raw source question options.
                    if (wireOptions(sourceQuestionComponent).length) {
                        wireOptions(sourceQuestionComponent).some(function (option, rawIndex) {
                            if (!option) return false;
                            if (conditionOptionIds.some(function (id) { return idsMatch(id, wireComponentId(option)); })) {
                                const rawOrder = option.orderIndex !== undefined ? option.orderIndex : option.order_index;
                                const optionIndex = Number.isInteger(rawOrder) ? rawOrder : rawIndex;
                                resolvedSelectedOptionId = buildOptionComponentId(sourceIndex, optionIndex);
                                return true;
                            }
                            return false;
                        });
                    }

                    // Fallback: match against normalized builder option ids directly.
                    if (resolvedSelectedOptionId === null) {
                        const directMatchedOption = sourceOptionItems.find(function (item) {
                            return conditionOptionIds.some(function (id) { return idsMatch(id, item.id); });
                        });

                        if (directMatchedOption) {
                            resolvedSelectedOptionId = directMatchedOption.id;
                        }
                    }

                    if (builderQuestion.visibility.operator === 'EQUALS' && resolvedSelectedOptionId !== null) {
                        const numericOptionId = Number(resolvedSelectedOptionId);
                        builderQuestion.visibility.selectedOptionId = Number.isNaN(numericOptionId)
                            ? resolvedSelectedOptionId
                            : numericOptionId;
                    }
                }

                enforceConditionalOperator(builderQuestion);

                if (builderQuestion.visibility.operator === 'EQUALS' && (builderQuestion.visibility.selectedOptionId === null || builderQuestion.visibility.selectedOptionId === undefined || String(builderQuestion.visibility.selectedOptionId).trim() === '')) {
                    const fallbackOptions = getQuestionOptionItems(normalizedQuestions[sourceIndex], sourceIndex);
                    if (fallbackOptions.length > 0) {
                        builderQuestion.visibility.selectedOptionId = fallbackOptions[0].id;
                    }
                }
            });

            return normalizedQuestions;
        }

        $scope.startEditTemplate = function () {
            $scope.setTemplateAction('edit');
        };

        $scope.selectTemplateMenu = function (template) {
            if (!template) return;
            const templateId = templateIdOf(template);
            $scope.selectedTemplate = templateId;
            $scope.drawer.activeRoot = templateId;
            $scope.setTemplateAction('preview');
            rebuildGroups();
        };

        $scope.isTemplateExpanded = function (template) {
            return template && $scope.drawer.activeRoot === templateIdOf(template);
        };

        $scope.setTemplateAction = function (action) {
            const selected = getSelectedTemplateObj();
            if (!selected) return;

            const selectedId = templateIdOf(selected);
            $scope.drawer.activeRoot = selectedId;
            $scope.drawer.templateAction = action;

            if (action === 'preview') {
                resetPreviewState();
                $scope.previewImageCache = {};
                $scope.objectUrls = [];
                $scope.previewSendState.success = '';
                $scope.previewSendState.error = '';
                refreshPreviewComponents();
            }

            if (action === 'edit') {
                const questions = loadQuestionsFromTemplate(selected);
                $scope.builder = {
                    mode: 'edit',
                    editTemplateId: selectedId,
                    name: templateTitleOf(selected),
                    questions: questions,
                    error: '',
                };
                loadStoredImagesForBuilder(selectedId);
            }

            if (action === 'answers') {
                $scope.loadAnswersForSelectedTemplate();
            }

            rebuildGroups();
        };

        $scope.togglePreviewMultiOption = function (blockKey, optionId) {
            if (!blockKey || optionId === null || optionId === undefined) return;
            if (!$scope.previewState.multi[blockKey]) {
                $scope.previewState.multi[blockKey] = {};
            }
            const key = normalizeId(optionId);
            $scope.previewState.multi[blockKey][key] = !$scope.previewState.multi[blockKey][key];
        };

        $scope.isPreviewMultiSelected = function (blockKey, optionId) {
            const selected = $scope.previewState.multi[blockKey];
            return !!(selected && selected[normalizeId(optionId)]);
        };

        $scope.selectPreviewOption = function (blockKey, optionId) {
            if (!blockKey) return;
            $scope.previewState.single[blockKey] = optionId;
        };

        $scope.isPreviewOptionSelected = function (blockKey, optionId) {
            return idsMatch($scope.previewState.single[blockKey], optionId);
        };

        /* Preview draws a saved template, so its images come from S3 behind the bearer
           token - same blob-to-object-URL route the builder rows use. Cached per
           component id so a digest does not refetch on every pass. */
        $scope.previewImageCache = {};
        $scope.objectUrls = [];

        $scope.previewImageSrc = function (block, option) {
            const componentId = wireComponentId(option);
            const templateId = $scope.selectedTemplate;
            if (!templateId || componentId === null || componentId === undefined) return '';
            // No stored file means the upload never completed - the endpoint would 500.
            if (!option || !option.image) return '';

            const key = templateId + ':' + componentId;
            if ($scope.previewImageCache[key] !== undefined) {
                return $scope.previewImageCache[key];
            }

            $scope.previewImageCache[key] = '';
            $scope.PatientFormsAPI.getComponentImage(templateId, componentId)
                .then(function (resp) {
                    const url = $window.URL.createObjectURL(resp.data);
                    $scope.objectUrls.push(url);
                    $scope.previewImageCache[key] = url;
                })
                .catch(function () {
                    $scope.previewImageCache[key] = '';
                });

            return '';
        };

        $scope.answerImageSrc = function (answerValue) {
            if (!answerValue || answerValue.componentId === null || answerValue.componentId === undefined) {
                return '';
            }
            return $scope.previewImageSrc(null, {
                componentId: answerValue.componentId,
                image: true,
            });
        };

        /* Recognised the same way the reload path recognises it: the last text option
           reading "Other". Selecting it reveals a box, and what is typed there is
           submitted as an answer_string on the question alongside the option's id. */
        $scope.isOtherOption = function (block, option) {
            const options = wireOptions(block);
            if (!options.length) return false;
            if (wireComponentId(options[options.length - 1]) !== wireComponentId(option)) return false;
            return isOtherOptionText(wireOptionText(option));
        };

        $scope.isPreviewOtherActive = function (block, blockKey) {
            const options = wireOptions(block);
            if (!options.length) return false;

            const last = options[options.length - 1];
            if (!isOtherOptionText(wireOptionText(last))) return false;

            const lastId = wireComponentId(last);
            if (getPreviewResponseType(block) === 'multipleChoice') {
                return $scope.isPreviewMultiSelected(blockKey, lastId);
            }
            return $scope.isPreviewOptionSelected(blockKey, lastId);
        };

        $scope.getPreviewBlockKey = getPreviewBlockKey;
        $scope.getPreviewOptions = wireOptions;
        $scope.previewOptionId = wireComponentId;
        $scope.previewOptionText = wireOptionText;
        $scope.previewOptionAltText = wireOptionAltText;
        $scope.previewOptionIsImage = wireOptionIsImage;

        $scope.previewImageMissing = function (option) {
            return wireOptionIsImage(option) && !(option && option.image);
        };

        function getPreviewSelectedOptionIds(sourceBlock, sourceBlockIndex) {
            if (!sourceBlock) return [];

            const sourceKey = getPreviewBlockKey(sourceBlock, sourceBlockIndex);

            if (getPreviewResponseType(sourceBlock) === 'multipleChoice') {
                const selectedMap = $scope.previewState.multi[sourceKey];
                if (!selectedMap) return [];
                return Object.keys(selectedMap).filter(function (optionId) {
                    return !!selectedMap[optionId];
                });
            }

            const selected = $scope.previewState.single[sourceKey];
            return normalizeId(selected) ? [selected] : [];
        }

        function isPreviewQuestionAnswered(sourceBlock, sourceBlockIndex) {
            if (!sourceBlock) return false;

            const sourceKey = getPreviewBlockKey(sourceBlock, sourceBlockIndex);
            const responseType = getPreviewResponseType(sourceBlock);

            if (responseType === 'freeText') {
                const textValue = ($scope.previewState && $scope.previewState.text)
                    ? $scope.previewState.text[sourceKey]
                    : '';
                return !!String(textValue || '').trim();
            }

            if (responseType === 'multipleChoice') {
                const selectedMap = $scope.previewState.multi[sourceKey];
                return !!(selectedMap && Object.keys(selectedMap).some(function (optionId) {
                    return !!selectedMap[optionId];
                }));
            }

            const singleValue = ($scope.previewState && $scope.previewState.single)
                ? $scope.previewState.single[sourceKey]
                : '';
            return !!String(singleValue || '').trim();
        }

        function evaluateVisibilityCondition(condition, sourceBlock, sourceBlockIndex) {
            if (!condition || !sourceBlock) return false;

            const operator = condition.operator || 'EQUALS';
            if (operator === 'IS_ANSWERED') {
                return isPreviewQuestionAnswered(sourceBlock, sourceBlockIndex);
            }

            if (operator === 'EQUALS') {
                const selectedOptionIds = getPreviewSelectedOptionIds(sourceBlock, sourceBlockIndex);
                const conditionOptionIds = getConditionOptionIds(condition);
                if (conditionOptionIds.length === 0) {
                    return false;
                }
                return conditionOptionIds.some(function (conditionOptionId) {
                    return selectedOptionIds.some(function (selectedOptionId) {
                        return idsMatch(conditionOptionId, selectedOptionId);
                    });
                });
            }

            return false;
        }

        function clearPreviewAnswerForBlock(block, blockIndex) {
            const blockKey = getPreviewBlockKey(block, blockIndex);
            if (!$scope.previewState || !blockKey) return;

            if ($scope.previewState.text && Object.prototype.hasOwnProperty.call($scope.previewState.text, blockKey)) {
                delete $scope.previewState.text[blockKey];
            }

            if ($scope.previewState.single && Object.prototype.hasOwnProperty.call($scope.previewState.single, blockKey)) {
                delete $scope.previewState.single[blockKey];
            }

            if ($scope.previewState.multi && Object.prototype.hasOwnProperty.call($scope.previewState.multi, blockKey)) {
                delete $scope.previewState.multi[blockKey];
            }

        }

        $scope.isPreviewBlockVisible = function (block, blockIndex, allBlocks) {
            if (!block || wireVisibilityConditions(block).length === 0) {
                return true;
            }

            const blocks = Array.isArray(allBlocks) ? allBlocks : [];
            const conditionResults = wireVisibilityConditions(block).map(function (condition) {
                const conditionSourceId = wireConditionSourceId(condition);
                if (conditionSourceId === undefined || conditionSourceId === null) {
                    return false;
                }

                let sourceBlockIndex = -1;
                const sourceBlock = blocks.find(function (candidate, idx) {
                    const matches = candidate && String(wireComponentId(candidate)) === String(conditionSourceId);
                    if (matches) {
                        sourceBlockIndex = idx;
                    }
                    return matches;
                });

                return evaluateVisibilityCondition(condition, sourceBlock, sourceBlockIndex);
            });

            if (block.visibilityLogic === 'ANY') {
                const isVisible = conditionResults.some(function (value) { return !!value; });
                if (!isVisible) {
                    clearPreviewAnswerForBlock(block, blockIndex);
                }
                return isVisible;
            }

            const isVisible = conditionResults.every(function (value) { return !!value; });
            if (!isVisible) {
                clearPreviewAnswerForBlock(block, blockIndex);
            }
            return isVisible;
        };

        function buildRenderedAnswers(entry, template) {
            const rawAnswers = entry && Array.isArray(entry.answers) ? entry.answers : [];
            const components = template && Array.isArray(template.components)
                ? template.components
                : (template && Array.isArray(template.questions) ? template.questions : []);
            const renderedByComponentId = {};
            const renderedAnswers = [];

            rawAnswers.forEach(function (answer) {
                if (!answer) return;

                // component_id and answer_component ARE generated DTO fields, so these
                // two stay snake_case while their contents do not.
                const componentId = answer.component_id !== undefined
                    ? answer.component_id
                    : answer.componentId;
                const answerComponent = answer.answer_component || answer.answerComponent || {};
                const component = components.find(function (candidate) {
                    return candidate && idsMatch(wireComponentId(candidate), componentId);
                });
                const componentKey = normalizeId(componentId);
                let rendered = renderedByComponentId[componentKey];

                if (!rendered) {
                    rendered = {
                        componentId: componentId,
                        question: (component && (wireQuestionText(component) || component.label)) || ('Question ' + componentId),
                        isImageQuestion: resolveResponseType(component) === 'imageChoice',
                        values: [],
                    };
                    renderedByComponentId[componentKey] = rendered;
                    renderedAnswers.push(rendered);
                }

                // answer_component is a generated field, but what it holds is the
                // hand-written AbstractAnswerComponent - so camelCase inside.
                const answerString = answerComponent.answerString !== undefined
                    ? answerComponent.answerString
                    : answerComponent.answer_string;
                const answerId = answerComponent.answerId !== undefined
                    ? answerComponent.answerId
                    : answerComponent.answer_id;

                if (answerString !== undefined && answerString !== null) {
                    rendered.values.push(String(answerString));
                    return;
                }

                if (answerId !== undefined && answerId !== null) {
                    const options = wireOptions(component);
                    const option = options.find(function (candidate) {
                        return candidate && idsMatch(wireComponentId(candidate), answerId);
                    });
                    rendered.values.push({
                        componentId: answerId,
                        value: option && (wireOptionText(option) || wireOptionAltText(option))
                            ? (wireOptionText(option) || wireOptionAltText(option))
                            : String(answerId),
                    });
                }
            });

            return renderedAnswers.map(function (answer) {
                return {
                    componentId: answer.componentId,
                    question: answer.question,
                    isImageQuestion: answer.isImageQuestion,
                    values: answer.values,
                    value: answer.values.map(function (value) {
                        return typeof value === 'object' ? value.value : value;
                    }).join(', '),
                };
            });
        }

        $scope.loadAnswersForSelectedTemplate = function () {
            const selected = getSelectedTemplateObj();
            if (!selected || !$scope.patientId) {
                $scope.answersView.items = [];
                $scope.answersView.error = 'Patient or template is not available.';
                return;
            }

            const selectedId = templateIdOf(selected);

            $scope.answersView.loading = true;
            $scope.answersView.error = '';
            $scope.PatientFormsAPI.getCustomFormAnswers(selectedId, $scope.patientId)
                .then(function (resp) {
                    const data = resp && resp.data;
                    const entries = Array.isArray(data) ? data : (data ? [data] : []);
                    $scope.answersView.items = entries.map(function (entry) {
                        return Object.assign({}, entry, {
                            renderedAnswers: buildRenderedAnswers(entry, selected),
                        });
                    });
                })
                .catch(function (error) {
                    console.error(error);
                    /* Clear first: an empty list is now the "not submitted yet" answer, so
                       anything reaching here is a real failure and must not leave the previous
                       template's answers on screen underneath the error. */
                    $scope.answersView.items = [];
                    $scope.answersView.error = 'Failed to load answers for this template.';
                })
                .finally(function () {
                    $scope.answersView.loading = false;
                });
        };

        $scope.getAnswerEntries = function (answers) {
            if (!answers || typeof answers !== 'object') return [];
            return Object.keys(answers).map(function (key) {
                return {
                    key: key,
                    value: answers[key],
                };
            });
        };

        $scope.formatAnswerValue = function (value) {
            if (Array.isArray(value)) {
                return value.join(', ');
            }
            if (value === null || value === undefined) {
                return '';
            }
            return String(value);
        };

        $scope.responseTypeLabel = function (type) {
            if (type === 'yesNo') return 'Yes/No';
            if (type === 'freeText') return 'Free text';
            if (type === 'singleChoice') return 'Single choice';
            if (type === 'multipleChoice') return 'Multiple choice';
            if (type === 'imageChoice') return 'Image choice';
            return type || 'Unknown';
        };

        $scope.isImageQuestionType = function (type) {
            return type === 'imageChoice';
        };

        $scope.isTextChoiceType = function (type) {
            return type === 'singleChoice' || type === 'multipleChoice';
        };

        $scope.getQuestionTypeLabel = function (component) {
            if (!component) return 'Unknown';
            return $scope.responseTypeLabel(getPreviewResponseType(component));
        };

        $scope.getQuestionOptionsText = function (component) {
            if (!component) return '';

            if (Array.isArray(component.options) && component.options.length > 0) {
                return component.options
                    .map(function (option) {
                        // Builder questions hold {uid, text}; a loaded template holds plain strings.
                        return option && typeof option === 'object' ? option.text : option;
                    })
                    .filter(function (text) { return !!text; })
                    .join(', ');
            }

            if (wireOptions(component).length > 0) {
                return wireOptions(component)
                    .map(function (opt) { return wireOptionText(opt) || wireOptionAltText(opt); })
                    .filter(function (text) { return !!text; })
                    .join(', ');
            }

            return '';
        };

        $scope.getConditionalOperatorLabel = function (question) {
            return $scope.getConditionalOperator(question) === 'IS_ANSWERED' ? 'Is answered' : 'Equals';
        };

        $scope.getConditionalOperator = function (question) {
            const sourceQuestion = getSourceQuestionFromVisibility(question);
            return getEnforcedVisibilityOperatorBySourceQuestion(sourceQuestion);
        };

        function getQuestionIndex(question) {
            if (!$scope.builder || !Array.isArray($scope.builder.questions)) return -1;
            return $scope.builder.questions.indexOf(question);
        }

        /* "Question 3" counts questions only, so adding a header does not renumber them. */
        $scope.componentLabel = function (item, index) {
            if (!isQuestionItem(item)) {
                const type = CUSTOM_FORM_COMPONENT_TYPES.find(function (candidate) {
                    return candidate.kind === item.kind;
                });
                return type ? type.label : 'Component';
            }

            const items = ($scope.builder && Array.isArray($scope.builder.questions)) ? $scope.builder.questions : [];
            const number = items.slice(0, index + 1).filter(isQuestionItem).length;
            return 'Question ' + (number || index + 1);
        };

        $scope.hasEarlierQuestion = function (index) {
            const items = ($scope.builder && Array.isArray($scope.builder.questions)) ? $scope.builder.questions : [];
            return items.slice(0, index).some(isQuestionItem);
        };

        $scope.getConditionSourceQuestions = function (questionIndex, question) {
            const questions = ($scope.builder && Array.isArray($scope.builder.questions))
                ? $scope.builder.questions
                : EMPTY_LIST;

            if (!Number.isInteger(questionIndex) || questionIndex <= 0) {
                return EMPTY_LIST;
            }

            const cacheKey = 'source-' + questionIndex;
            const signature = getSourceQuestionsSignature(questions, questionIndex);
            const cachedSources = conditionalSourceCache[cacheKey];
            if (cachedSources && cachedSources.signature === signature) {
                return cachedSources.value;
            }

            const computedSources = questions
                .slice(0, questionIndex)
                .map(function (question, index) {
                    return {
                        index: index,
                        isQuestion: isQuestionItem(question),
                        label: (question && question.label) ? question.label : $scope.componentLabel(question, index),
                        options: getQuestionOptionItems(question, index),
                        isFreeText: question && question.responseType === 'freeText',
                    };
                })
                .filter(function (source) {
                    // Headers and images have no answer, so they cannot drive conditional visibility.
                    return source.isQuestion && (source.isFreeText || source.options.length > 0);
                });

            conditionalSourceCache[cacheKey] = {
                signature: signature,
                value: computedSources,
            };

            return computedSources;
        };

        $scope.getConditionOptions = function (question) {
            const sourceIndex = getVisibilitySourceIndex(question);
            if (sourceIndex === null) {
                return EMPTY_LIST;
            }

            const sourceQuestion = $scope.builder.questions[sourceIndex];
            if (!sourceQuestion) {
                return EMPTY_LIST;
            }

            const cacheKey = 'options-' + sourceIndex;
            const signature = sourceIndex + '::' + getQuestionSignature(sourceQuestion);
            const cachedOptions = conditionalOptionsCache[cacheKey];
            if (cachedOptions && cachedOptions.signature === signature) {
                return cachedOptions.value;
            }

            const computedOptions = getQuestionOptionItems(sourceQuestion, sourceIndex);
            conditionalOptionsCache[cacheKey] = {
                signature: signature,
                value: computedOptions,
            };

            return computedOptions;
        };

        $scope.onConditionalToggle = function (question, questionIndex) {
            if (!question || !question.visibility) return;

            if (!question.visibility.enabled) {
                question.visibility.sourceQuestionIndex = null;
                question.visibility.lastSourceQuestionIndex = null;
                question.visibility.operator = 'EQUALS';
                question.visibility.selectedOptionId = null;
                question.visibility.selectedOptionIds = [];
                question.visibility.value = '';
                return;
            }

            if (!question.visibility.operator) {
                question.visibility.operator = 'EQUALS';
            }

            const availableSources = $scope.getConditionSourceQuestions(questionIndex, question);
            if (!availableSources.length) {
                question.visibility.enabled = false;
                question.visibility.sourceQuestionIndex = null;
                question.visibility.lastSourceQuestionIndex = null;
                question.visibility.operator = 'EQUALS';
                question.visibility.selectedOptionId = null;
                question.visibility.selectedOptionIds = [];
                question.visibility.value = '';
                return;
            }

            const currentSourceIndex = getVisibilitySourceIndex(question);
            if (currentSourceIndex === null) {
                question.visibility.sourceQuestionIndex = availableSources[0].index;
                question.visibility.lastSourceQuestionIndex = availableSources[0].index;
            } else {
                question.visibility.sourceQuestionIndex = currentSourceIndex;
                question.visibility.lastSourceQuestionIndex = currentSourceIndex;
            }

            enforceConditionalOperator(question);
        };

        $scope.onConditionalSourceChanged = function (question) {
            if (!question || !question.visibility) return;

            const currentSourceIndex = getVisibilitySourceIndex(question);
            const previousSourceIndex = Number.isInteger(question.visibility.lastSourceQuestionIndex)
                ? question.visibility.lastSourceQuestionIndex
                : null;

            if (previousSourceIndex !== null && currentSourceIndex === previousSourceIndex) {
                enforceConditionalOperator(question);
                return;
            }

            question.visibility.selectedOptionId = null;
            question.visibility.selectedOptionIds = [];
            question.visibility.value = '';

            const questionIndex = getQuestionIndex(question);
            const availableSources = $scope.getConditionSourceQuestions(questionIndex, question);
            const isCurrentSourceAvailable = availableSources.some(function (source) {
                return source.index === currentSourceIndex;
            });
            if (!isCurrentSourceAvailable) {
                question.visibility.sourceQuestionIndex = availableSources.length ? availableSources[0].index : null;
            } else {
                question.visibility.sourceQuestionIndex = currentSourceIndex;
            }

            question.visibility.lastSourceQuestionIndex = getVisibilitySourceIndex(question);

            enforceConditionalOperator(question);
        };

        $scope.isYesNoQuestion = function (component) {
            if (!component) return false;

            if (component.responseType === 'yesNo') {
                return true;
            }

            if ($scope.getQuestionTypeLabel(component) === 'Yes/No') {
                return true;
            }

            const normalizedOptions = $scope.getQuestionOptionsText(component)
                .toLowerCase()
                .replace(/\s+/g, '');

            return normalizedOptions === 'yes,no';
        };

        $scope.isHeaderComponent = function (component) {
            return !!wireHeaderText(component);
        };

        $scope.isTextComponent = function (component) {
            return !!(component && (component.text_content || component.textContent)
                && !wireQuestionText(component) && !component.header_text && !component.headerText);
        };

        $scope.isImageComponent = wireIsImage;

        $scope.isQuestionComponent = function (component) {
            if (wireIsHeader(component) || wireIsImage(component)) return false;
            return !!(component && (wireQuestionText(component) || component.label || component.responseType || wireOptions(component).length));
        };

        $scope.previewHeaderText = wireHeaderText;

        $scope.getPreviewComponents = function (template) {
            if (!template) return [];

            if (Array.isArray(template.components) && template.components.length > 0) {
                return template.components.slice().sort(function (a, b) {
                    const aIndex = typeof a.orderIndex === 'number' ? a.orderIndex : 0;
                    const bIndex = typeof b.orderIndex === 'number' ? b.orderIndex : 0;
                    return aIndex - bIndex;
                });
            }

            return loadQuestionsFromTemplate(template);
        };

        $scope.getPreviewQuestions = function (template) {
            if (!template) return [];
            return loadQuestionsFromTemplate(template);
        };

        $scope.startCreateTemplate = function () {
            resetBuilder('create');
            $scope.drawer.activeRoot = 'create';
            $scope.drawer.templateAction = 'create';
        };

        function performTemplateDelete() {
            $scope.PatientFormsAPI.isProcessing = true;
            $scope.PatientFormsAPI.deleteCustomForm($scope.selectedTemplate)
                .then(function () {
                    $scope.templates = $scope.templates.filter(function (template) {
                        return templateIdOf(template) !== $scope.selectedTemplate;
                    });
                    $scope.selectedTemplate = $scope.templates.length ? templateIdOf($scope.templates[0]) : null;
                    if ($scope.builder.mode === 'edit') {
                        resetBuilder('create');
                    }
                    $scope.drawer.activeRoot = 'create';
                    $scope.drawer.templateAction = 'create';
                    rebuildGroups();
                })
                .catch(function (error) {
                    console.error(error);
                    $scope.builder.error = 'Failed to delete template. Please try again.';
                })
                .finally(function () {
                    $scope.PatientFormsAPI.isProcessing = false;
                });
        }

        /* The house delete modal, same as the file uploader's, rather than a native confirm
           or a Material one. Bootstrap's modal sits at z-index 1050 against md-dialog-container's
           80, so it layers over the Patient Forms dialog without the dialog needing to move. */
        $scope.deleteSelectedTemplate = function () {
            if (!$scope.selectedTemplate || $scope.deleteTemplateModal) return;

            $scope.deleteTemplateName = templateTitleOf(getSelectedTemplateObj());
            $scope.deleteTemplateModal = $modal({
                scope: $scope,
                templateUrl: 'app/src/views/templates/modal.confirm-delete-form-template.tpl.html',
                show: true,
                backdrop: 'static',
            });
        };

        function dismissDeleteTemplateModal() {
            if (!$scope.deleteTemplateModal) return;
            $scope.deleteTemplateModal.hide();
            $scope.deleteTemplateModal = null;
        }

        $scope.cancelDeleteTemplate = function () {
            dismissDeleteTemplateModal();
            // The rail moved its highlight onto this template on the way in, so put it back
            // in step with the pane that is actually showing.
            rebuildGroups();
        };

        $scope.confirmDeleteTemplate = function () {
            dismissDeleteTemplateModal();
            performTemplateDelete();
        };

        $scope.addComponent = function (kind) {
            const create = COMPONENT_FACTORIES[kind];
            if (!create) return;

            const item = create();
            $scope.builder.questions.push(item);
            clearConditionalCaches();

            // The palette is beside the list, so bring the new card into view.
            $timeout(function () {
                const el = document.getElementById('pfItem-' + item.uid);
                if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
        };

        $scope.onResponseTypeChange = function (question) {
            if (!question) return;

            if (!Array.isArray(question.options)) {
                question.options = [];
            }

            /* Switching between a text choice and an image choice swaps what the rows
               are, so the rows are replaced rather than reinterpreted - an image row
               has no text to keep, and a text row has no file. */
            if ($scope.isImageQuestionType(question.responseType)) {
                if (!question.options.length || question.options.some(function (o) { return !isImageOption(o); })) {
                    question.options = [defaultImageOptionRow(), defaultImageOptionRow()];
                }
                // "Other" is a text box; there is nothing to type next to a picture.
                question.allowOther = false;
                clearConditionalCaches();
                return;
            }

            // Two blank rows to start: a choice question with one option is not a choice.
            if ($scope.isTextChoiceType(question.responseType)) {
                if (!question.options.length || question.options.some(isImageOption)) {
                    question.options = [defaultOption(), defaultOption()];
                }
                clearConditionalCaches();
                return;
            }

            question.allowOther = false;
            clearConditionalCaches();
        };

        /* Adding or removing "Other" adds or removes a real option, so anything keyed off
           the option list - the conditional pickers, their cached ids - has to be rebuilt. */
        $scope.addOtherOption = function (question) {
            if (!question || !$scope.isTextChoiceType(question.responseType)) return;
            question.allowOther = true;
            clearConditionalCaches();
        };

        $scope.removeOtherOption = function (question) {
            if (!question) return;
            question.allowOther = false;
            clearConditionalCaches();
        };

        $scope.addOption = function (question, afterIndex) {
            if (!question) return null;
            if (!Array.isArray(question.options)) {
                question.options = [];
            }

            const option = defaultOption();
            const index = typeof afterIndex === 'number' ? afterIndex + 1 : question.options.length;
            question.options.splice(index, 0, option);
            clearConditionalCaches();
            return option;
        };

        $scope.removeOption = function (question, index) {
            if (!question || !Array.isArray(question.options)) return;
            if (question.options.length <= 1) return;
            question.options.splice(index, 1);
            clearConditionalCaches();
        };

        /* Enter adds the next row and puts the caret in it, so a list of options can be
           typed straight through without reaching for the mouse. The row is rendered on
           the digest this handler is part of, hence the $timeout before focusing. */
        $scope.onOptionKeydown = function (event, question, index) {
            if (!event || event.keyCode !== 13) return;
            event.preventDefault();

            const option = $scope.addOption(question, index);
            if (!option) return;

            $timeout(function () {
                const el = document.getElementById('pfOpt-' + option.uid);
                if (el) el.focus();
            });
        };

        /* A condition names its source question by position, and the option ids it picks are built
           from that position too, so any move or removal has to re-point it at the same question in
           its new place. A condition whose question is gone, or now comes after it, is switched off
           rather than left quietly pointing at whatever took that slot. */
        function changeItemOrder(mutate) {
            const items = $scope.builder.questions;
            const links = items.map(function (item) {
                const sourceIndex = getVisibilitySourceIndex(item);
                if (!item.visibility || !item.visibility.enabled || sourceIndex === null) return null;
                const selected = item.visibility.selectedOptionId;
                const hasSelected = selected !== null && selected !== undefined && String(selected).trim() !== '';
                return {
                    item: item,
                    source: items[sourceIndex],
                    optionIndex: hasSelected ? Number(selected) - buildOptionComponentId(sourceIndex, 0) : null,
                };
            }).filter(Boolean);

            mutate(items);

            links.forEach(function (link) {
                const itemIndex = items.indexOf(link.item);
                if (itemIndex === -1) return;

                const sourceIndex = items.indexOf(link.source);
                if (sourceIndex === -1 || sourceIndex >= itemIndex) {
                    link.item.visibility.enabled = false;
                    $scope.onConditionalToggle(link.item, itemIndex);
                    return;
                }

                link.item.visibility.sourceQuestionIndex = sourceIndex;
                link.item.visibility.lastSourceQuestionIndex = sourceIndex;
                if (link.optionIndex !== null && !Number.isNaN(link.optionIndex)) {
                    link.item.visibility.selectedOptionId = buildOptionComponentId(sourceIndex, link.optionIndex);
                }
            });

            clearConditionalCaches();
        }

        $scope.removeQuestion = function (index) {
            if ($scope.builder.questions.length <= 1) return;
            changeItemOrder(function (items) {
                items.splice(index, 1);
            });
        };

        /* `to` is the slot to insert before, counted before the move - what the drag-reorder
           directive reports. The up/down buttons go through here too. */
        $scope.moveComponent = function (from, to) {
            const items = $scope.builder.questions;
            if (!Number.isInteger(from) || !Number.isInteger(to)) return;
            if (from < 0 || from >= items.length || to < 0 || to > items.length) return;
            const target = from < to ? to - 1 : to;
            if (target === from) return;

            changeItemOrder(function (list) {
                const moved = list.splice(from, 1)[0];
                list.splice(target, 0, moved);
            });
        };

        $scope.moveQuestionUp = function (index) {
            $scope.moveComponent(index, index - 1);
        };

        $scope.moveQuestionDown = function (index) {
            $scope.moveComponent(index, index + 2);
        };

        $scope.addImageRow = function (question) {
            if (!question) return;
            if (!Array.isArray(question.options)) {
                question.options = [];
            }
            question.options.push(defaultImageOptionRow());
            clearConditionalCaches();
        };

        /* Holds the File itself, not base64. The bytes are PUT after the template is
           saved, and a data URL is only ever used to draw the row before then. */
        $scope.onOptionImageChanged = function (inputEl) {
            if (!inputEl || !inputEl.files || !inputEl.files.length) return;

            const questionIndex = Number(inputEl.getAttribute('data-question-index'));
            const optionIndex = Number(inputEl.getAttribute('data-option-index'));
            if (Number.isNaN(questionIndex) || Number.isNaN(optionIndex)) return;

            const question = $scope.builder.questions[questionIndex];
            const option = question && Array.isArray(question.options)
                ? question.options[optionIndex]
                : null;
            if (!option) return;

            readPickedImage(inputEl, option);
        };

        $scope.onImageComponentChanged = function (inputEl) {
            if (!inputEl || !inputEl.files || !inputEl.files.length) return;

            const index = Number(inputEl.getAttribute('data-question-index'));
            const item = Number.isNaN(index) ? null : $scope.builder.questions[index];
            if (!item || item.kind !== 'image') return;

            readPickedImage(inputEl, item);
        };

        // `target` is an image option row or an image component; both carry the same fields.
        function readPickedImage(inputEl, target) {
            const file = inputEl.files[0];
            if (file.size > MAX_IMAGE_BYTES) {
                $scope.$applyAsync(function () {
                    $scope.builder.error = 'Images must be 20MB or smaller. "' + file.name + '" is larger than that.';
                });
                inputEl.value = '';
                return;
            }

            const reader = new FileReader();
            reader.onload = function (event) {
                $scope.$applyAsync(function () {
                    target.file = file;
                    target.previewSrc = event && event.target ? event.target.result : '';
                    target.hasStoredImage = false;
                    target.uploadFailed = false;
                    if (!String(target.altText || '').trim()) {
                        target.altText = file.name.replace(/\.[^/.]+$/, '');
                    }
                    $scope.builder.error = '';
                    clearConditionalCaches();
                });
            };
            reader.readAsDataURL(file);
        }

        /* A saved image lives in S3 and its GET needs the bearer token, so an <img src>
           cannot fetch it. Pull the bytes as a blob once and hand the row an object URL.
           Revoked on dialog teardown. */
        function loadStoredOptionImage(templateId, option) {
            if (!templateId || !option || !option.storedImage || option.previewSrc || option.imageLoading) return;

            option.imageLoading = true;
            $scope.PatientFormsAPI.getComponentImage(templateId, option.storedComponentId)
                .then(function (resp) {
                    const url = $window.URL.createObjectURL(resp.data);
                    $scope.objectUrls.push(url);
                    option.previewSrc = url;
                })
                .catch(function () {
                    option.imageFailed = true;
                })
                .finally(function () {
                    option.imageLoading = false;
                });
        }

        function loadStoredImagesForBuilder(templateId) {
            if (!templateId) return;
            $scope.builder.questions.forEach(function (question) {
                if (question.kind === 'image') {
                    loadStoredOptionImage(templateId, question);
                    return;
                }
                (question.options || []).forEach(function (option) {
                    loadStoredOptionImage(templateId, option);
                });
            });
        }

        $scope.$on('$destroy', function () {
            $scope.objectUrls.forEach(function (url) {
                $window.URL.revokeObjectURL(url);
            });
        });

        /* Component keys are camelCase, the envelope's are snake_case, and the split is
           not arbitrary. The RAML declares components in snake_case but marks them
           "existingJavaType": AbstractFormComponent - so no DTO is generated for them and
           Jackson binds straight to the hand-written services classes, which carry no
           @JsonProperty and are named by their bean properties: componentId, questionText,
           questionOptions, textContent, altText. Only the envelope (form_title, components)
           is a generated DTO with snake_case @JsonProperty.

           Sending components in snake_case is not merely ignored: AbstractFormComponent
           uses @JsonTypeInfo(Id.DEDUCTION), which picks the subtype from the property names
           present. With snake_case keys the only names Jackson recognises are "required" (on
           all four subtypes) and "components" (on question and header) - two candidates, and
           a 400 before anything is saved. */
        function buildQuestionOptions(question, questionIndex) {
            const rows = getUsableOptions(question).slice();

            // Appended last so the ids of the real options do not shift when it is
            // toggled on or off, which would break any conditional pointing at them.
            if (questionAllowsOther(question)) {
                rows.push({ text: OTHER_OPTION_TEXT, isImage: false });
            }

            return rows.map(function (option, optionIndex) {
                const component = {
                    componentId: buildOptionComponentId(questionIndex, optionIndex),
                    orderIndex: optionIndex,
                    isHidden: false,
                    visibilityConditions: [],
                    visibilityLogic: 'ALL',
                };

                if (isImageOption(option)) {
                    component.altText = String(option.altText || '').trim()
                        || (question.label ? question.label + ' option ' + (optionIndex + 1) : 'Image ' + (optionIndex + 1));

                    /* Re-sent so the server still sees the object as referenced. A pending
                       upload keeps it too: the PUT writes to the same key, so the old object
                       is overwritten rather than orphaned. */
                    if (option.storedImage) {
                        component.image = option.storedImage;
                    }
                } else {
                    component.textContent = String(option.text || '').trim();
                }

                return component;
            });
        }

        function buildYesNoOptions(questionIndex) {
            return ['Yes', 'No'].map(function (text, optionIndex) {
                return {
                    componentId: buildOptionComponentId(questionIndex, optionIndex),
                    orderIndex: optionIndex,
                    isHidden: false,
                    visibilityConditions: [],
                    visibilityLogic: 'ALL',
                    textContent: text,
                };
            });
        }

        function buildVisibilityConditions(question, index) {
            const sourceIndex = getVisibilitySourceIndex(question);
            if (
                index === 0
                || !question.visibility
                || !question.visibility.enabled
                || sourceIndex === null
                || sourceIndex >= index
            ) {
                return [];
            }

            const sourceQuestion = $scope.builder.questions[sourceIndex];
            if (!isQuestionItem(sourceQuestion)) {
                return [];
            }

            const condition = {
                sourceComponentId: sourceIndex + 1,
                operator: getEnforcedVisibilityOperatorBySourceQuestion(sourceQuestion),
                optionIds: [],
                value: '',
            };

            if (condition.operator === 'EQUALS') {
                const selected = question.visibility.selectedOptionId;
                if (selected !== null && selected !== undefined && String(selected).trim() !== '') {
                    condition.optionIds = [Number(selected)];
                }
                if (condition.optionIds.length !== 1) {
                    return [];
                }
            }

            return [condition];
        }

        function buildTemplatePayload() {
            const components = $scope.builder.questions.map(function (question, index) {
                const responseType = question.responseType;

                const component = {
                    componentId: index + 1,
                    orderIndex: index,
                    isHidden: false,
                    required: isQuestionItem(question) && !!question.required,
                    visibilityConditions: buildVisibilityConditions(question, index),
                    visibilityLogic: 'ALL',
                };

                // headerText / altText are what the API's type deduction keys on.
                if (question.kind === 'header') {
                    component.headerText = String(question.headerText || '').trim();
                    component.headerSize = '2';
                    component.components = [];
                    return component;
                }

                if (question.kind === 'image') {
                    component.altText = String(question.altText || '').trim();
                    // Re-sent for the same reason as an image option's - see buildQuestionOptions.
                    if (question.storedImage) {
                        component.image = question.storedImage;
                    }
                    return component;
                }

                component.questionText = question.label;
                component.components = [];

                if (responseType === 'freeText') {
                    component.allowMultipleSelections = false;
                    component.questionOptions = [];
                    return component;
                }

                if (responseType === 'yesNo') {
                    component.allowMultipleSelections = false;
                    component.questionOptions = buildYesNoOptions(index);
                    component.displayStyle = 'RADIO_BUTTON';
                    return component;
                }

                // Every remaining type is a choice question; imageChoice differs only in its
                // options carrying alt_text and bytes.
                const isMulti = responseType === 'multipleChoice';
                component.allowMultipleSelections = isMulti;
                component.questionOptions = buildQuestionOptions(question, index);
                component.displayStyle = isMulti ? 'CHECKBOX' : 'RADIO_BUTTON';
                return component;
            });

            return {
                form_title: $scope.builder.name,
                components: components,
            };
        }

        /* Existing images must be read before the update replaces the component list.
           The upload endpoint accepts a File, not the stored image metadata, so rebuild
           one from the authenticated blob response before queueing the replacement. */
        function collectPendingImageUploads(sourceTemplateId) {
            const pending = [];
            const storedImageFiles = [];

            function queueImage(option, componentId) {
                const pendingItem = {
                    componentId: componentId,
                    option: option,
                    altText: String(option.altText || '').trim(),
                };
                pending.push(pendingItem);

                if (!option.file && option.storedImage && option.storedComponentId !== undefined) {
                    storedImageFiles.push(
                        $scope.PatientFormsAPI.getComponentImage(sourceTemplateId, option.storedComponentId)
                            .then(function (resp) {
                                const blob = resp.data;
                                const fileName = pendingItem.altText || ('image-' + option.storedComponentId);
                                option.file = new File([blob], fileName, {
                                    type: blob.type || 'application/octet-stream',
                                });
                            })
                    );
                }
            }

            $scope.builder.questions.forEach(function (question, questionIndex) {
                // A top-level image's componentId is its position, same as in the payload.
                if (question.kind === 'image') {
                    if (question.file || question.storedImage) {
                        queueImage(question, questionIndex + 1);
                    }
                    return;
                }

                if (!$scope.isImageQuestionType(question.responseType)) return;

                getUsableOptions(question).forEach(function (option, optionIndex) {
                    if (!isImageOption(option)) return;
                    queueImage(option, buildOptionComponentId(questionIndex, optionIndex));
                });
            });

            return $q.all(storedImageFiles).then(function () {
                return pending;
            });
        }

        function validateBuilder() {
            if (!$scope.builder.name || !$scope.builder.name.trim()) {
                return 'Template name is required.';
            }

            const hasInvalidComponent = $scope.builder.questions.some(function (item) {
                if (item.kind === 'header') {
                    return !String(item.headerText || '').trim();
                }
                if (item.kind === 'image') {
                    return !String(item.altText || '').trim() || !(item.file || item.storedImage);
                }
                return false;
            });

            const hasInvalidQuestion = $scope.builder.questions.some(function (question) {
                if (!isQuestionItem(question)) return false;
                if (!question.label || !question.label.trim()) {
                    return true;
                }
                if (question.responseType === 'singleChoice' || question.responseType === 'multipleChoice') {
                    return getOptionTexts(question).length === 0;
                }
                if (question.responseType === 'imageChoice') {
                    return getUsableOptions(question).length === 0;
                }
                return false;
            });

            /* An image row with no file is left out of the payload, so saving over it
               would quietly drop the option. Say so instead - the usual cause is an
               upload that failed earlier and still needs re-selecting. */
            const hasEmptyImageRow = $scope.builder.questions.some(function (question) {
                if (!$scope.isImageQuestionType(question.responseType)) return false;
                return (question.options || []).some(function (option) {
                    return isImageOption(option) && !option.file && !option.storedImage;
                });
            });

            const hasInvalidVisibility = $scope.builder.questions.some(function (question, questionIndex) {
                if (!question || questionIndex === 0) return false;
                if (!question.visibility || !question.visibility.enabled) return false;

                const sourceIndex = getVisibilitySourceIndex(question);
                if (sourceIndex === null) {
                    return true;
                }

                if (sourceIndex >= questionIndex) {
                    return true;
                }

                const sourceQuestion = $scope.builder.questions[sourceIndex];
                if (!isQuestionItem(sourceQuestion)) {
                    return true;
                }

                const operator = getEnforcedVisibilityOperatorBySourceQuestion(sourceQuestion);
                if (operator === 'EQUALS') {
                    if (question.visibility.selectedOptionId === null || question.visibility.selectedOptionId === undefined || String(question.visibility.selectedOptionId).trim() === '') {
                        return true;
                    }
                }

                return false;
            });

            if (hasInvalidQuestion) {
                return 'Every question must have text. Choice questions need options, and image questions need an uploaded image file.';
            }
            if (hasInvalidComponent) {
                return 'Every header needs text, and every image needs a picture and a description.';
            }
            if (hasEmptyImageRow) {
                return 'Every image option needs a picture. Choose a file for the ones marked below, or remove them.';
            }
            if (hasInvalidVisibility) {
                return 'Conditional visibility requires a previous question and a matching option.';
            }
            return '';
        }

        function toSavedTemplate(form, fallbackName) {
            const data = form || {};
            return {
                id: data.patient_custom_form_template_id || data.id,
                patient_custom_form_template_id: data.patient_custom_form_template_id || data.id,
                name: data.form_title || data.name || fallbackName,
                form_title: data.form_title || data.name || fallbackName,
                status: data.status || 'draft',
                components: data.components || [],
            };
        }

        /* Phase two of the save. Images go one at a time rather than in parallel: the
           endpoint returns the whole updated template on each call, and the API caps a
           template at 15 images, so a serial chain keeps the last response authoritative
           and keeps a big form from opening fifteen uploads at once. */
        function uploadPendingImages(templateId, pending, lastResponse) {
            if (!pending.length) {
                return $q.resolve(lastResponse);
            }

            return pending.reduce(function (chain, item) {
                return chain.then(function (previous) {
                    return $scope.PatientFormsAPI
                        .uploadComponentImage(templateId, item.componentId, item.option.file, item.altText)
                        .then(function (resp) {
                            // Uploaded: the bytes now live server-side, so the row stops
                            // carrying the File and points at its stored image instead.
                            item.option.file = null;
                            item.option.hasStoredImage = true;
                            item.option.storedComponentId = item.componentId;
                            return resp;
                        })
                        .catch(function (error) {
                            console.error('Image upload failed for component ' + item.componentId, error && error.status);
                            item.option.uploadFailed = true;
                            return previous;
                        });
                });
            }, $q.resolve(lastResponse));
        }

        $scope.saveTemplate = function () {
            $scope.builder.error = validateBuilder();
            if ($scope.builder.error) return;

            const payload = buildTemplatePayload();
            const wasEdit = $scope.builder.mode === 'edit' && !!$scope.builder.editTemplateId;
            let pendingImages = [];

            $scope.PatientFormsAPI.isProcessing = true;

            collectPendingImageUploads(wasEdit ? $scope.builder.editTemplateId : null)
                .then(function (items) {
                    pendingImages = items;
                    return wasEdit
                        ? $scope.PatientFormsAPI.updateCustomForm($scope.builder.editTemplateId, payload)
                        : $scope.PatientFormsAPI.createCustomForm(payload);
                })
                .then(function (resp) {
                    const savedTemplateId = (resp.data || {}).patient_custom_form_template_id || (resp.data || {}).id;
                    // The template has to exist before its images can be attached: the
                    // upload endpoint targets a component_id within a saved template.
                    return uploadPendingImages(savedTemplateId, pendingImages, resp);
                })
                .then(function (resp) {
                    const savedTemplate = toSavedTemplate(resp.data, $scope.builder.name);
                    const savedTemplateId = templateIdOf(savedTemplate);

                    if (savedTemplateId) {
                        const existingIndex = $scope.templates.findIndex(function (template) {
                            return templateIdOf(template) === savedTemplateId;
                        });

                        if (existingIndex > -1) {
                            $scope.templates[existingIndex] = savedTemplate;
                        } else {
                            $scope.templates.unshift(savedTemplate);
                        }

                        $scope.selectedTemplate = savedTemplateId;
                    }

                    const failed = pendingImages.filter(function (item) { return item.option.uploadFailed; });
                    if (failed.length) {
                        $scope.builder.error = failed.length === 1
                            ? 'The template saved, but one image failed to upload. Re-select it and save again.'
                            : 'The template saved, but ' + failed.length + ' images failed to upload. Re-select them and save again.';
                        return;
                    }

                    if (wasEdit) {
                        $scope.setTemplateAction('preview');
                    } else {
                        resetBuilder('create');
                        $scope.drawer.activeRoot = 'create';
                        $scope.drawer.templateAction = 'create';
                        rebuildGroups();
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    $scope.builder.error = wasEdit
                        ? 'Failed to update template. Please try again.'
                        : 'Failed to create template. Please try again.';
                })
                .finally(function () {
                    $scope.PatientFormsAPI.isProcessing = false;
                });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.sendTemplateToPatient = function () {
            if (!$scope.selectedTemplate || !$scope.patientId) {
                $scope.previewSendState.success = '';
                $scope.previewSendState.error = 'Patient or template is not available.';
                return;
            }

            $scope.previewSendState.success = '';
            $scope.previewSendState.error = '';
            $scope.PatientFormsAPI.isProcessing = true;

            $scope.PatientFormsAPI.sendCustomFormTemplateToPatient($scope.selectedTemplate, $scope.patientId)
                .then(function () {
                    $scope.previewSendState.success = 'Form sent to patient successfully.';
                })
                .catch(function (error) {
                    console.error(error);
                    $scope.previewSendState.error = 'Failed to send form to patient. Please try again.';
                })
                .finally(function () {
                    $scope.PatientFormsAPI.isProcessing = false;
                });
        };

        if ($scope.selectedTemplate) {
            $scope.drawer.activeRoot = $scope.selectedTemplate;
            $scope.drawer.templateAction = 'preview';
            refreshPreviewComponents();
        }

        rebuildGroups();
    },
]);
